ACC.warrantysearch = {
  showwarranty: function() {
    $(document).on('click', '.ph-findserialnumber', function() {
      ACC.warrantysearch.findmyserialnumber();
    });
  },
  findmyserialnumber: function() {
    $.colorbox({
      html: $('.ph-warrantysearch__findserialnumberpopup').html(),
      maxWidth: '500px',
      width: '100%',
      height: 'auto',
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onClosed: function() {
        $('html').removeClass('ph-modal-open');
      }
    });
  }
};
$(document).ready(function() {
  if ($('.ph-serialentry').length > 0) {
    $('.ph-serialentry').each(function() {
      var inputVal = $(this).val();

      $(this).focus(function() {
        if (this.value === inputVal) {
          $('.ph-textarealabel').addClass('hidden');
        }
      }).blur(function() {
        if (this.value === '') {
          $('.ph-textarealabel').removeClass('hidden');
        } else {
          $('.ph-textarealabel').addClass('hidden');
        }
      });
    });
  }

  if ($('.ph-serialentry').val() !== '' && $('.ph-serialentry').val() !== null) {
    $('.ph-textarealabel').addClass('hidden');
  } else {
    $('.ph-textarealabel').removeClass('hidden');
  }

  ACC.warrantysearch.showwarranty();
});
